import _get from 'lodash/get';

function Ctrl($scope, $state, $stateParams, utilsService, jsSdkVenueInfo, loggerService, metaTagService) {
  $scope.loading = true;

  $scope.$watch('$parent.venue', function(newValue) {
    if (newValue && newValue.id) {
      $scope.venue = $scope.$parent.venue;

      _readVenueInfo($scope.venue.id, $stateParams.page);

      utilsService.scrollTo('description', 200, 300);

      let title;

      switch ($stateParams.page) {
        case 'bottle-service':
          title = `VIP Bottle Service at ${$scope.venue.name}`;
          break;
        case 'tickets':
          title = `Buy Tickets at ${$scope.venue.name}`;
          break;
        case 'cover':
          title = `Get on the Guest List at ${$scope.venue.name}`;
          break;
        default:
          title = `Learn More About ${$scope.venue.name}`;
          break;
      }

      metaTagService.set({
        title: title,
        description: `Book VIP tables, customize bottle service, create a guest list, or purchase tickets for exclusive events at ${$scope.venue.name} with Tablelist.`,
        facebookImage: _get($scope, ['venue', 'primaryImage', 'xlarge']),
        canonicalPath: `/v/${$scope.venue.seoPathname}/${$stateParams.page}`
      });
    }
  });

  function _readVenueInfo(venueId, page) {

    if (!venueId) {
      loggerService.error('Unable to load venue information. Missing venueId');

      $scope.loading = false;

      return;
    }

    if (!page) {
      $scope.loading = false;

      $state.go('^');

      return;
    }

    jsSdkVenueInfo.read(venueId, {
        key: page
      })
      .then(function _success(resp) {
        $scope.page = resp;

        $scope.loading = false;

      })
      .catch(() => {
        $scope.page = {
          title: 'Requested Info not Found',
          text: 'The information you requested could not be found.'
        };

        $scope.loading = false;
      });
  }
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'utilsService',
  'jsSdk.venueInfo',
  'loggerService',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/venueInfo/venueInfoCtrl.js